import { useCallback, useEffect, useRef, useState } from "react";

import useEventListener from "../../../../../hooks/useEventListener";
import { getDefaultScrollConfig } from "../../../../../helpers";

const IDLE_TIMEOUT = 2000;
const listenerConfig = getDefaultScrollConfig();

export const useCursorTrack = (timeout = IDLE_TIMEOUT): [boolean] => {
  const [state, setState] = useState({
    x: 0,
    y: 0,
    isIdle: false,
    touchLock: false,
  });

  const timer = useRef(null);

  const debounceHide = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (!state.touchLock) {
        setState({ ...state, isIdle: true });
      }
    }, timeout);
  }, [state, timeout]);

  useEffect(() => {
    debounceHide();
    return () => {
      clearTimeout(timer.current);
    };
  }, [debounceHide]);

  const handleMouseMove = useCallback(
    (event) => {
      if (state.x !== event.clientX || state.y !== event.clientY) {
        setState({
          ...state,
          x: event.clientX,
          y: event.clientY,
          isIdle: false,
        });
        debounceHide();
      }
    },
    [state, debounceHide],
  );

  const handleTouchStart = useCallback(() => {
    setState({ ...state, touchLock: true, isIdle: false });
  }, [state]);

  const handleTouchEnd = useCallback(() => {
    setState({ ...state, touchLock: false });
  }, [state]);

  useEventListener("mousemove", handleMouseMove);
  useEventListener("touchmove", handleMouseMove, listenerConfig);
  useEventListener("touchstart", handleTouchStart, listenerConfig);
  useEventListener("touchend", handleTouchEnd, listenerConfig);
  useEventListener("mousedown", handleTouchStart);
  useEventListener("mouseup", handleTouchEnd);

  return [state.isIdle];
};
